import React, { useEffect, useMemo, useState } from "react"
import { Container, Card, CardBody, Row, Col, Input, Label, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import classnames from "classnames"
import Breadcrumbs from "components/Common/Breadcrumb"
import secureLocalStorage from "react-secure-storage"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import Loader from "pages/Separate/Loader"
import Swal from "sweetalert2"

const EarningDeduction = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [loading, setLoading] = useState(false)

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  const [fixedSideTab, setFixedSideTab] = useState(false)

  useEffect(() => {
    document.addEventListener("scroll", () => {
      if (window.scrollY > 68) {
        setFixedSideTab(true)
      } else {
        setFixedSideTab(false)
      }
    })
    document.title = "Earning / Deduction | Zithas Crm"
    const fetchNodeData = async () => {
      const token = secureLocalStorage.getItem("auth_token")
      try {
        const response = await fetchNodeData(
          setLoading,
          "earningAndDeduction/get",
          token
        )

        if (response.success && response.data.length) {
          const {
            id,
            basicpay,
            houseRentAllowance,
            dearnessAllowance,
            allowance,
            pf,
            esi,
            pt,
            otherDeductions,
          } = response.data[0]

          setEarnings({
            basic: basicpay,
            hra: houseRentAllowance,
            da: dearnessAllowance,
            allowances: allowance,
            id: id,
          })

          setDeductions({
            pf: pf,
            esi: esi,
            pt: pt,
            other: otherDeductions,
          })
        }
      } catch (err) {
        console.log(err)
      }
    }
    fetchNodeData()
  }, [])

  const [earnings, setEarnings] = useState({
    basic: "",
    hra: "",
    da: "",
    allowances: "",
  })

  const [deductions, setDeductions] = useState({
    pf: "",
    esi: "",
    pt: "",
    other: "",
  })

  const total = useMemo(
    () =>
      Number(earnings.basic || 0) +
      Number(earnings.hra || 0) +
      Number(earnings.da || 0) +
      Number(earnings.allowances || 0),
    [earnings]
  )

  const handleSubmit = type => {
    const token = secureLocalStorage.getItem("auth_token")

    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `You want to save ${type === 1 ? "earnings" : "deductions"}`,
      showCancelButton: true,
    }).then(async willOkay => {
      if (willOkay.isConfirmed) {
        try {
          let entry
          if (type === 1) {
            if (total !== 100) {
              swal("Oops!", "Total of values must be 100%", "warning")
              return
            }
            entry = {
              basicpay: earnings.basic,
              houseRentAllowance: earnings.hra,
              dearnessAllowance: earnings.da,
              allowance: earnings.allowances,
            }
          } else {
            entry = {
              pf: deductions.pf,
              esi: deductions.esi,
              pt: deductions.pt,
              otherDeductions: deductions.other,
            }
          }

          if (earnings?.id) {
            entry.id = earnings?.id
          }

          let response = await FetchNodePostData(
            setLoading,
            `earningAndDeduction/post`,
            token,
            entry
          )

          if (response.data.success) {
            setEarnings(prev => ({ ...prev, id: response.data.data.id }))
            Swal.fire(
              "Saved!",
              `${type === 1 ? "Earnings" : "Deductions"} saved successfully.`,
              "success"
            )
          }
        } catch (error) {
          console.log(error)
          swal("", "Something went wrong!", "error")
        }
      }
    })
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumbs title="Dashboard" breadcrumbItem="Earning / Deduction" />

        <Row className="gx-4 justify-content-between di-flex align-items-top">
          <Col md="2" className="px-0">
            <Nav
              pills
              className={`side-tab flex-column px-2 py-3 bg-white  ${
                fixedSideTab ? "fixed-side-tab" : ""
              } h-100`}
            >
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    "mb-2": true,
                    active: verticalActiveTab === "1",
                  })}
                  onClick={() => {
                    toggleVertical("1")
                  }}
                >
                  Earnings
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    "mb-2": true,
                    active: verticalActiveTab === "2",
                  })}
                  onClick={() => {
                    toggleVertical("2")
                  }}
                >
                  Deductions
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col md="10" className="pe-0">
            <div className="card p-4 h-100">
              <TabContent
                activeTab={verticalActiveTab}
                className="text-muted mt-4 mt-md-0"
              >
                <TabPane tabId="1">
                  <div className="p-4 border rounded bg-light w-75">
                    <h6 className="mb-3 fw-bold text-muted d-flex justify-content-between">
                      <span>
                        <i className={`fas fa-arrow-up me-2`}></i>
                        Earnings Configuration
                      </span>{" "}
                      <span className="text-warning">
                        <i className="bx bx-info-circle me-1"></i> Total of
                        values must be 100%.
                      </span>
                    </h6>

                    <Row className="g-3">
                      <Col md={6}>
                        <Label>Basic Pay (%)</Label>
                        <Input
                          type="number"
                          className="form-control"
                          placeholder="e.g. 40"
                          value={earnings.basic}
                          onChange={e => {
                            setEarnings({
                              ...earnings,
                              basic: e.target.value,
                            })
                          }}
                        />
                      </Col>

                      <Col md={6}>
                        <Label className="">House Rent Allowance (%)</Label>
                        <Input
                          type="number"
                          className="form-control"
                          placeholder="e.g. 20"
                          value={earnings.hra}
                          onChange={e =>
                            setEarnings({
                              ...earnings,
                              hra: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6}>
                        <Label className="">Dearness Allowance (%)</Label>
                        <Input
                          type="number"
                          className="form-control"
                          placeholder="e.g. 10"
                          value={earnings.da}
                          onChange={e =>
                            setEarnings({
                              ...earnings,
                              da: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6}>
                        <Label className="">Allowances (%)</Label>
                        <Input
                          type="number"
                          className="form-control"
                          placeholder="e.g. 15"
                          value={earnings.allowances}
                          onChange={e =>
                            setEarnings({
                              ...earnings,
                              allowances: e.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    <div
                      className={`text-${
                        total == 100 ? "success" : "danger"
                      } my-4 fs-6 fw-semibold`}
                    >
                      Total: {total}%
                    </div>

                    <div>
                      <button
                        type="button"
                        disabled={total !== 100}
                        onClick={() => handleSubmit(1)}
                        className="border-radius btn btn-purple"
                      >
                        <i className="fas fa-save me-2"></i> Save
                      </button>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="p-4 border rounded bg-light w-75">
                    <h6 className="mb-3 fw-bold text-muted">
                      <i className={`fas fa-arrow-down me-2`}></i>
                      Percentage-based Deductions
                    </h6>

                    <Row className="g-3 mb-3">
                      <Col md={6}>
                        <Label className="">PF (% of Basic)</Label>
                        <Input
                          className="form-control"
                          placeholder="e.g. 12"
                          value={deductions.pf}
                          onChange={e =>
                            setDeductions({
                              ...deductions,
                              pf: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6}>
                        <Label className="">ESI (% of Gross)</Label>
                        <Input
                          className="form-control"
                          placeholder="e.g. 1.75"
                          value={deductions.esi}
                          onChange={e =>
                            setDeductions({
                              ...deductions,
                              esi: e.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    <h6 className="mb-3 mt-5 fw-bold text-muted ">
                      <i className={`fas fa-arrow-down me-2`}></i>
                      Fixed Deductions
                    </h6>

                    <Row className="g-3">
                      <Col md={6}>
                        <Label className="">PT (Fixed)</Label>
                        <Input
                          className="form-control"
                          placeholder="e.g. 200"
                          value={deductions.pt}
                          onChange={e =>
                            setDeductions({
                              ...deductions,
                              pt: e.target.value,
                            })
                          }
                        />
                      </Col>

                      <Col md={6}>
                        <Label className="">Other Deductions</Label>
                        <Input
                          className="form-control"
                          placeholder="Enter amount"
                          value={deductions.other}
                          onChange={e =>
                            setDeductions({
                              ...deductions,
                              other: e.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>

                    <div className="mt-5">
                      <button
                        type="button"
                        onClick={() => handleSubmit(2)}
                        className="border-radius btn btn-purple"
                      >
                        <i className="fas fa-save me-2"></i> Save
                      </button>
                    </div>
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default EarningDeduction
